import React from 'react';
import { useDispatch } from 'react-redux';
import { useDidMount } from 'rooks';
import TestListModule from '../../modules/TestList';
import TestEditorModule from '../../modules/TestEditor';
import { changeActiveTest, resetEditor } from '../../redux/actions';

const MyTestsPage = () => {
	const dispatch = useDispatch();

	useDidMount(() => {
		dispatch(resetEditor());
		dispatch(changeActiveTest(null));
	});

	return (
		<>
			<TestListModule />
			<TestEditorModule mode="preview" />
		</>
	);
};

export default MyTestsPage;
